import { createAction, props } from '@ngrx/store';

import { IMenuItem } from '@shared/types';

const SELECT_SIDEBAR_ITEM = 'SELECT_SIDEBAR_ITEM';

const SET_MENU_ITEMS = 'SET_MENU_ITEMS';
const ENABLE_CONTENT_LOADER = 'ENABLE_CONTENT_LOADER';
const DISABLE_CONTENT_LOADER = 'DISABLE_CONTENT_LOADER';
const FORCE_DISABLE_CONTENT_LOADER = 'FORCE_DISABLE_CONTENT_LOADER';

const INIT_APP = 'INIT_APP';

const init_app = createAction(`[SESSION_REDUCER] ${INIT_APP}`);

const select_sidebar_item = createAction(
    `[UI_REDUCER] ${SELECT_SIDEBAR_ITEM}`,
    props<{ selectedMenuItem: IMenuItem | string }>(),
);
const set_menu_items = createAction(`[UI_REDUCER] ${SET_MENU_ITEMS}`, props<{ menuItems: Array<IMenuItem> }>());

const enable_content_loader = createAction(`[UI_REDUCER] ${ENABLE_CONTENT_LOADER}`);
const disable_content_loader = createAction(`[UI_REDUCER] ${DISABLE_CONTENT_LOADER}`);
const force_disable_content_loader = createAction(`[UI_REDUCER] ${FORCE_DISABLE_CONTENT_LOADER}`);

export {
    init_app,
    select_sidebar_item,
    set_menu_items,
    enable_content_loader,
    disable_content_loader,
    force_disable_content_loader,
};
